import React from "react"
import numeral from "numeral"
import DateHelper from "../../DateHelper/DateHelper"
import {format} from "date-fns"

class TaxOrFeeRateDataType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFormat: DateHelper.rubyToDateFNS(this.props.date_format),
    }
  }

  render() {
    if(this.props.row.percentage && !this.props.row.amount || this.props.row.amount === 0){
      var taxDatesRate = <li key={this.props.row.id}>{parseFloat((this.props.row.percentage * 100).toFixed(4))}% <br/> ({format(DateHelper.parseDate(this.props.row.start_date), this.state.dateFormat)} - {DateHelper.parseDate(this.props.row.end_date) ? format(DateHelper.parseDate(this.props.row.end_date), this.state.dateFormat) : 'No End Date'})</li>
    } else if (this.props.row.amount && !this.props.row.percentage || this.props.row.percentage === 0) {
      var taxDatesRate = <li key={this.props.row.id}>{numeral(this.props.row.amount / 100).format(this.props.currency_unit + '0' + this.props.delimiter + '0' + this.props.separator + '00')} {I18n.t('per')} {this.capitalizeFirstLetter(I18n.t(this.props.row.unit))} <br/> ({format(DateHelper.parseDate(this.props.row.start_date), this.state.dateFormat)} - {DateHelper.parseDate(this.props.row.end_date) ? format(DateHelper.parseDate(this.props.row.end_date), this.state.dateFormat) : 'No End Date'})</li>
    }

    return (
        <ul style={{ marginBottom: 0 }}>{taxDatesRate}</ul>
    )
  };

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
};

export default TaxOrFeeRateDataType
